import Vue from 'vue'
import VueRouter from 'vue-router'
import EventList from '../views/EventList.vue'
import EventDetails from '../views/EventDetails.vue'

Vue.use(VueRouter)

const routes = [
    { 
        path: '/', 
        name: 'EventList', 
        component: EventList,
        props: true,
        title: 'Mosclim 2.0'
    },
    { 
        path: '/events/:id', 
        name: 'EventDetails', 
        component: EventDetails,
        props: true,
        meta: { title: 'Mosclim 2.0' }
    }
]

const router = new VueRouter({
    routes // short for `routes: routes`
})

export default router